import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { UtilsService } from '@taxilla-library/lib/services/utils/utils.service';

@Component({
    selector: 'material-menu-button',
    templateUrl: './menu-button.component.html',
    styleUrls: ['./menu-button.component.scss'],
    standalone: false,
})
export class MaterialMenuButtonComponent {
    @ViewChild('matMenuTrigger', { static: false }) trigger: MatMenuTrigger;
    @Input() text = '';
    @Input() description = '';
    @Input() color: 'primary' | 'danger' | 'warning' | 'default' | 'primary-lite' = 'default';
    @Input() buttonType: 'raised' | 'flat' | 'stroked' | 'icon' | 'fab' | 'mini-fab' = 'raised';
    @Input() size: 'small' | 'medium' | 'large' = 'medium';
    @Input() loading = false;
    @Input() loadingText = 'Loading...';
    @Input() disabled = false;
    @Input() disableText = false;
    @Input() hidden = false;
    @Input() isToggled = false;
    @Input() textColor = '';
    @Input() classList: string[] = [];
    @Input() prefixIconClassList: string[] = [];
    @Input() suffixIconClassList: string[] = [];
    @Input() menuClassList = '';
    @Input() textClassList: string[] = [];
    @Input() labelClassList: string[] = [];
    @Input() prefixImgClassList: string[] = [];
    @Input() suffixImgClassList: string[] = [];
    @Input() titleText = '';
    @Input() prefixIcon = '';
    @Input() suffixIcon = '';
    @Input() prefixIconType: 'material' | 'image' | 'svg' = 'material';
    @Input() prefixIconAppearance: 'outlined' | 'filled' = 'outlined';
    @Input() arrowIconAppearance: 'outlined' | 'filled' = 'outlined';
    @Input() arrowClassList = '';
    @Input() badgeClassList = '';
    @Input() suffixIconType: 'material' | 'image' | 'svg' = 'material';
    @Input() suffixIconAppearance: 'outlined' | 'filled' = 'outlined';
    @Input() prefixImgSrc = '';
    @Input() suffixImgSrc = '';
    @Input() prefixSvgIcon = '';
    @Input() suffixSvgIcon = '';
    @Input() prefixImgAlt = '';
    @Input() suffixImgAlt = '';
    @Input() showArrows = false;
    @Input() showBadge = false;
    @Input() badgeText: string | number = '';
    @Input() hideRipple = false;
    @Input() xPosition: 'before' | 'after' = 'after';
    @Input() yPosition: 'above' | 'below' = 'below';
    @Input() overlapTrigger = false;

    @Output() mouseEnteredEvent = new EventEmitter<MouseEvent>();
    @Output() mouseLeftEvent = new EventEmitter<MouseEvent>();
    @Output() buttonClicked = new EventEmitter<MouseEvent>();
    @Output() menuClosedAction = new EventEmitter<any>();
    @Output() menuOpenedAction = new EventEmitter<any>();
    @Output() menuButtonClosedAction = new EventEmitter<any>();
    @Output() menuButtonOpenedAction = new EventEmitter<any>();

    computedClassList: string[] = [];
    id = UtilsService.guid();

    constructor() {}

    ngOnChanges(_changes: SimpleChanges): void {
        this.updateClassList();
    }

    private updateClassList(): void {
        const classes = ['mdc-button'];

        // Add button type class
        switch (this.buttonType) {
            case 'raised':
                classes.push('mat-mdc-raised-button');
                break;
            case 'flat':
                classes.push('mat-mdc-button');
                break;
            case 'stroked':
                classes.push('mat-mdc-outlined-button');
                break;
            case 'icon':
                classes.push('mat-mdc-icon-button');
                break;
            case 'fab':
                classes.push('mat-mdc-fab');
                break;
            case 'mini-fab':
                classes.push('mat-mdc-mini-fab');
                break;
        }

        // Add color class
        if (this.color !== 'default') {
            classes.push(this.color);
        }

        // Add size class
        classes.push(this.size);

        // Add state classes
        if (this.loading) classes.push('loading');
        if (this.disabled) classes.push('disabled');
        if (this.disableText) classes.push('disabled');
        if (this.isToggled) classes.push('toggled');

        // Add custom classes
        if (this.classList && this.classList.length > 0) {
            classes.push(...this.classList);
        }

        this.computedClassList = classes.filter(value => value !== undefined && value !== null && value !== '');
        this.prefixIconClassList?.filter(value => value !== undefined && value !== null && value !== '');
        this.suffixIconClassList?.filter(value => value !== undefined && value !== null && value !== '');
        this.labelClassList?.filter(value => value !== undefined && value !== null && value !== '');
        this.textClassList?.filter(value => value !== undefined && value !== null && value !== '');
        this.prefixImgClassList?.filter(value => value !== undefined && value !== null && value !== '');
        this.suffixImgClassList?.filter(value => value !== undefined && value !== null && value !== '');
    }

    onButtonClick(event: MouseEvent): void {
        if (this.loading || this.disabled || this.disableText) {
            return;
        }
        this.buttonClicked.emit(event);
    }
}
